export default "__VITE_ASSET__8UXODwrt__"